import { SessionDuration } from "../models/SessionDuration";
import { ConfigValues } from "../models/ConfigValues";

type rtt = () => void;
type rtt2 = (system: string, errorCode: string) => void;

export default class SessionService {
  public static getSessionDuration = async (system: string): Promise<SessionDuration> => {
    const res = await fetch(`/status/api/session/duration/${system}`);
    if (res.ok) {
      const json = await res.json();
      return { expired: false, date: json.date };
    } else {
      return { expired: true, date: "" };
    }
  };

  public static prolongSession = (system: string) => {
    return fetch(`/status/api/session/prolong/${system}`, { method: "PUT" });
  };

  public static redirectToTiles: rtt & rtt2 = (system?: string, errorCode?: string) => {
    // TODO: Handle error codes
    window.parent.location.href = errorCode ? `/home/error/${system}/${errorCode}` : "/home/logout";
  };

  private static setIframeDisplay = (display: "block" | "none") => {
    const iframe = window.parent.document.getElementById("sessionExtender");
    if (iframe) {
      iframe.style.display = display;
    }
  };

  public static showIframe = () => {
    SessionService.setIframeDisplay("block");
    const root = window.parent.document.getElementById("root");
    if (root) {
      root.style.filter = "blur(10px)";
    }
  };
  public static hideIframe = () => {
    SessionService.setIframeDisplay("none");
    const root = window.parent.document.getElementById("root");
    if (root) {
      root.style.filter = "";
    }
  };

  public static getConfig = (): Promise<ConfigValues> =>
    fetch("/status/api/config").then(res => res.json());

  public static logout = () => {
    return fetch("/home/api/session", { method: "DELETE" })
      .then(() => SessionService.redirectToTiles())
      .catch(error => {
        // TODO: Handle failed logout (error codes)
        SessionService.logWarn(error, "Logout failed");
        SessionService.redirectToTiles();
      });
  };

  public static logWarn = (error: any, message: string = "") => {
    console.warn(`SESSION STATUS: ${message}`);
    console.warn(error);
  };
}
